// extracted by mini-css-extract-plugin
export default {"faq":"terms_faq__NqpIM","faq1":"terms_faq1__qhBVj"};